import { updateChatFormInputHeight } from "./updateChatFormInputHeight";
import { loadMappedModal } from "./displayModal";

export function sampleActions() {
    const $body = $('body');
    const $footerActions = $('.g-chatform-footer-actions');
    const $btnShow = $footerActions.find('.g-chatform-footer-actions-trigger');
    const COOKIE_KEY = 'g-chatform-footer-actions-visible';

    // Keep --quick-actions-width in sync with the rendered width of .g-chatform-quick-actions
    // so that .g-chatform-footer-actions.position-top left offset is always accurate.
    (function syncQuickActionsWidth() {
        const footerInner = document.querySelector('.g-chatform-footer-inner');
        const quickActions = footerInner?.querySelector('.g-chatform-quick-actions');
        if (!footerInner || !quickActions) return;

        const update = () => {
            footerInner.style.setProperty('--quick-actions-width', quickActions.offsetWidth + 'px');
        };

        update();

        if (typeof window.ResizeObserver === 'function') {
            new window.ResizeObserver(update).observe(quickActions);
        } else {
            window.addEventListener('resize', update);
        }
    })();

    function setFooterActionsVisible(isVisible) {
        $body.toggleClass('g-chatform-footer-actions-visible', isVisible);
        $footerActions.toggleClass('is-active', isVisible);
        growtypeCookie.setCookie(COOKIE_KEY, String(isVisible));
        $btnShow.attr('aria-expanded', isVisible);
    }

    // Open/close
    $btnShow.on('click', function () {
        const isActive = $footerActions.hasClass('is-active');
        if (isActive) {
            window.growtypeChatCloseSampleActions();
        } else {
            setFooterActionsVisible(true);
        }

        if ($('.g-chatform-quick-actions-grouped').hasClass('is-active')) {
            window.growtypeChatCloseGenerateContent();
        }
    });

    window.growtypeChatCloseSampleActions = function () {
        setFooterActionsVisible(false);
    };

    // Initial state
    const cookieValue = growtypeCookie.getCookie(COOKIE_KEY);
    if (cookieValue === null || cookieValue === 'true') {
        // setFooterActionsVisible(true);
    }

    // Actions list → load content
    $(document).on('click', '.actions-options-single', function () {
        const $el = $(this);
        const $modal = $el.closest('.modal');
        const $body = $modal.find('.modal-body');
        const $content = $body.find('.action-content');

        $el.closest('.actions-options').fadeOut(function () {
            $.ajax({
                url: growtype_chat_ajax.url,
                type: 'POST',
                data: {
                    action: 'growtype_chat_get_action',
                    action_name: $el.data('value'),
                    nonce: growtype_chat_ajax.nonce
                }
            })
                .done(function (response) {
                    if (response?.success) {
                        $modal.find('.modal-title').text($el.data('title') || '');
                        $modal.find('.btn-back').fadeIn();

                        // TODO: sanitize response.data.content on the server or here
                        $content.html(response.data.content).fadeIn();
                    } else {
                        console.warn('Action failed', response);
                    }
                })
                .fail(function (xhr) {
                    console.error('Ajax error', xhr);
                });
        });
    });

    // Modal back/reset
    $(document).on('click', '#growtypeChatGamesModal .btn-back', function () {
        const $modal = $('#growtypeChatGamesModal');
        $(this).fadeOut();
        $modal.find('.modal-body .action-content').empty().hide();
        $modal.find('.modal-body .actions-options').fadeIn();
        $modal.find('.modal-title').text('Games');
    });

    // Reset on close
    $(document).on('hidden.bs.modal', '#growtypeChatGamesModal', function () {
        const $m = $(this);
        $m.find('.btn-back').hide();
        $m.find('.modal-body .action-content').empty().hide();
        $m.find('.modal-body .actions-options').fadeIn();
        $m.find('.modal-title').text('Games');
    });

    // Sample message → fill input
    function bindSampleMessageSingle($scope) {
        $scope.off('click.sampleSingle', '.sample-message-single')
            .on('click.sampleSingle', '.sample-message-single', function () {
                const val = $(this).data('value') || '';
                $('.g-chatform .g-chatform-text-input').val(val).focus();
                // updateChatFormInputHeight();
            });
    }

    bindSampleMessageSingle($('.g-chatform'));

    // Sample message popover
    $(document).on('click', '.g-chatform .sample-message', function (e) {
        e.stopPropagation();

        const $self = $(this);
        const type = $self.data('type');

        if (type === 'modal') {
            loadMappedModal($self.data('value'));
            return;
        }

        const $group = $self.closest('.g-chatform-actions-groups');

        // Remove previous clones
        $group.find('.sample-message-content.is-cloned').fadeOut(300, function () {
            $(this).remove();
        });

        // Toggle active
        $('.g-chatform .sample-message').not($self).removeClass('is-active');
        const nowActive = !$self.hasClass('is-active');
        $self.toggleClass('is-active', nowActive);

        if (nowActive) {
            const $cloned = $self.find('.sample-message-content').clone().addClass('is-cloned').hide();
            $group.append($cloned);

            // Compute left position safely
            const groupWidth = $group.width();
            const selfLeft = $self.position().left;
            const cloneWidth = $cloned.outerWidth() || 210; // fallback
            let left = selfLeft;
            if (left + cloneWidth > groupWidth) left = Math.max(0, groupWidth - cloneWidth);

            $cloned.css('left', left).fadeIn(300);
            bindSampleMessageSingle($cloned);
        }

        // updateChatFormInputHeight();
    });
}
